const ALLOWED_TAGS = new Set([
    'P',
    'DIV',
    'BR',
    'STRONG',
    'B',
    'EM',
    'I',
    'U',
    'S',
    'STRIKE',
    'SUP',
    'SUB',
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6',
    'UL',
    'OL',
    'LI',
    'A',
    'SPAN',
    'CODE',
    'PRE',
    'BLOCKQUOTE',
    'TABLE',
    'TR',
    'TD',
    'TH',
    'TBODY',
    'THEAD'
]);

const LEGACY_BLOCK_TAG_NAME = 'DIV';
const PARAGRAPH_TAG_NAME = 'P';
const BLOCK_BREAK_PATTERN = /<div><br><\/div>/gi;

const cleanNode = (node: Node): void => {
    if (node.nodeType === Node.TEXT_NODE) {
        return;
    }

    if (node.nodeType === Node.ELEMENT_NODE) {
        const element = node as Element;
        const tagName = element.tagName.toUpperCase();

        if (!ALLOWED_TAGS.has(tagName)) {
            if (element.textContent) {
                const textNode = document.createTextNode(element.textContent);
                element.parentNode?.replaceChild(textNode, element);
            } else {
                element.remove();
            }

            return;
        }

        while (element.attributes.length > 0) {
            element.removeAttribute(element.attributes[0].name);
        }

        if (tagName === LEGACY_BLOCK_TAG_NAME) {
            const paragraph = document.createElement(PARAGRAPH_TAG_NAME.toLowerCase());

            while (element.firstChild) {
                paragraph.appendChild(element.firstChild);
            }

            element.parentNode?.replaceChild(paragraph, element);
            cleanNode(paragraph);

            return;
        }
    }

    Array.from(node.childNodes).forEach((child) => cleanNode(child));
};

export const sanitizePastedHtml = (html: string): string => {
    const parser = new DOMParser();
    const parsed = parser.parseFromString(html, 'text/html');
    const container = document.createElement('div');

    container.innerHTML = parsed.body.innerHTML;
    Array.from(container.childNodes).forEach((child) => cleanNode(child));

    return container.innerHTML;
};

export const normalizeLegacyEditorHtml = (html: string | null | undefined): string => {
    if (!html) {
        return '';
    }

    if (!html.includes('<div') && !html.includes('<DIV')) {
        return html;
    }

    return sanitizePastedHtml(html.replace(BLOCK_BREAK_PATTERN, '<p></p>'));
};

export const isMeaningfullyEmptyHtml = (html: string): boolean => {
    const parser = new DOMParser();
    const parsed = parser.parseFromString(html, 'text/html');
    const textContent = parsed.body.textContent?.replace(/\u00A0/g, ' ').trim() ?? '';

    if (textContent.length > 0) {
        return false;
    }

    return !parsed.body.querySelector('img,video,audio,iframe,table');
};
